<div class="box p-4">
  <div>
    {{'tariff_update_accounts' | translate: { NAME_PROJECT: NAME_PROJECT } }}.
  </div>
  <div class="d-flex justify-content-center">
    <app-button (onChangeClick)="click()">
      {{'increase_channel_limit' | translate}}
    </app-button>
  </div>
</div>
